import Vue from "vue";
import { IMaskDirective } from "vue-imask/esm/index";

Vue.directive("mask", IMaskDirective);
